<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">企业申报报表</li>
      <el-button
        type="primary"
        :icon="Upload"
        size="small"
        link
        @click="onExport"
        v-if="$judge_auth('576')"
        >导出
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-date-picker
        v-model="state.params.tax_month"
        type="month"
        placeholder="税款所属期"
        value-format="YYYY-MM"
        format="YYYY年M月"
        :clearable="false"
      />
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <c_statusradiogroup
        v-model="state.params.declare_type"
        arrName="taxdeclare_declare_type"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="declare_type_name"
          label="所得类型"
          :formatter="$tab_TextFormat"
          :min-width="100"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="企业名称"
          :formatter="$tab_TextFormat"
          :min-width="240"
        />
        <el-table-column
          prop="tax_bureau_name"
          label="所属税局"
          :formatter="$tab_TextFormat"
          :min-width="240"
        />
        <el-table-column
          prop="tax_month"
          label="税款所属月"
          :formatter="$tab_TextFormat"
          :min-width="120"
        />
        <el-table-column
          prop="declare_time"
          label="申报时间"
          :formatter="$tab_TextFormat"
          :min-width="120"
        />
        <el-table-column
          prop="total"
          label="申报人数"
          :formatter="$tab_TextFormat"
          :min-width="100"
        />
        <el-table-column
          prop="income_amount"
          label="收入总额"
          :formatter="$tab_PriceFormat"
          :min-width="120"
        />
        <el-table-column
          prop="tax_refund_amount"
          label="应补（退）税额"
          :formatter="$tab_PriceFormat"
          :min-width="120"
        />
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局获取欠费信息"
        @close="state.showAgent = false"
      >
        <c_Agent
          v-if="state.showAgent"
          :skssq="state.params.tax_month"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showSuccess"
        title="开具完税证明"
        @close="state.showSuccess = false"
      >
        <c_Success
          v-if="state.showSuccess"
          :skssq="state.params.tax_month"
          @close="state.showSuccess = false"
          @confirm="
            state.showSuccess = false;
            onLoad();
          "
        ></c_Success>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_TaxPayLog v-if="state.showLog"></c_TaxPayLog>
    </el-drawer>
    <el-drawer
      v-model="state.showSuccessLog"
      title="完税证明操作记录"
      size="70%"
    >
      <c_TaxPaySuccessLog v-if="state.showSuccessLog"></c_TaxPaySuccessLog>
    </el-drawer>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showSfxy"
        title="选择三方协议"
        @close="state.showSfxy = false"
      >
        <c_TaxPaySelectSfxy
          @close="state.showSfxy = false"
          :ids="state.selectIds"
        ></c_TaxPaySelectSfxy>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  taxdeclarereport_list,
  taxdeclarereport_export,
} from "@/http/taxdeclarereport";
import { dayjs, ElMessage } from "element-plus";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      taxdeclarereport_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;

          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      state.params.tax_month = dayjs().subtract(1, "month").format("YYYY-MM");
      onLoad();
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      taxdeclarereport_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onExport,
    };
  },
};
</script>
<style scoped></style>
